var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSurvey = function SvgAiSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 23"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 5.347,
    height: 11.879,
    x: 22.987,
    y: 0.667,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.667,
    height: 6.667,
    x: 13.333,
    y: 6.667,
    fill: "#CBFF88",
    rx: 3.333,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 9.708,
    y: 14.75,
    fill: "#CBFF88",
    rx: 2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M11.708 9.269h14v3.398l-1.833 1.875-2.042 2.208H11.708z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M26.42 11.835V2.914H14.246v12.174h8.921a.29.29 0 0 1 0 .58h-9.21a.29.29 0 0 1-.29-.29V2.623c0-.16.13-.29.29-.29H26.71c.16 0 .29.13.29.29v9.21a.29.29 0 0 1-.58 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "m16.995 8.087 1.921 1.92 4.755-4.754a.29.29 0 1 1 .41.41l-4.96 4.96a.29.29 0 0 1-.41 0l-2.125-2.126a.29.29 0 0 1 .41-.41M26.71 11.545a.29.29 0 0 1 .205.495l-3.543 3.542a.29.29 0 0 1-.494-.205v-3.542c0-.16.13-.29.29-.29zm-3.253 3.133 2.553-2.553h-2.553z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m34.5 0 .99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99z"
  })));
};
export { SvgAiSurvey as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-survey-c592373a1410172d16e6abe5da18d4df.svg";